import { TipologiaDocumentoDTO } from "../dto/tipologia-documentoDTO";
import { Injectable } from "@angular/core";
import { TipologiaDocumentoVO } from "../vo/tipologia-documentoVO";
import { MapperInterface } from "./mapper-inteface";
import { MapperCampoSpecificoConservazione } from "./mapper-campo-specifico-conservazione";
import { MapperValoriDefaultDocumento } from "./mapper-valori-default-documento";

@Injectable({
  providedIn: "root",
})
export class MapperTipologiaDocumento
  implements MapperInterface<TipologiaDocumentoDTO, TipologiaDocumentoVO> {
  constructor(
    private mapperCampoSpecificoConservazione: MapperCampoSpecificoConservazione,
    private mapperValoriDefaultDocumento: MapperValoriDefaultDocumento
  ) {}

  convertVoToDto(vo: TipologiaDocumentoVO): TipologiaDocumentoDTO {
    if (vo != null) {
      const dto = new TipologiaDocumentoDTO();
      dto.codice = vo.codice;
      dto.nome = vo.nome;
      dto.id = vo.id;
      //dto.anniConservazione = vo.anniConservazione;
      dto.campiSpecificiConservazione = this.mapperCampoSpecificoConservazione.convertListVoToDto(
        vo.campiSpecificiConservazione
      );
      /*  if (vo.valoriDefaultDocumento !== null) {
        dto.valoriDefaultDocumento = this.mapperValoriDefaultDocumento.convertVoToDto(
          vo.valoriDefaultDocumento
        );
      } */
      dto.codice = vo.codice;
      dto.dataManuale = vo.dataManuale;
      dto.descrizione = vo.descrizione;
      dto.motivazione = vo.motivazione;
      // TODO terminare
      return dto;
    } else {
      return null;
    }
  }
  convertDtoToVo(dto: TipologiaDocumentoDTO): TipologiaDocumentoVO {
    if (dto != null) {
      const vo = new TipologiaDocumentoVO();
      vo.codice = dto.codice;
      vo.nome = dto.nome;
      vo.id = dto.id;
      vo.anniConservazioneDaChiusura = dto.anniConservazioneDaChiusura;
      vo.campiSpecificiConservazione = this.mapperCampoSpecificoConservazione.convertListDtoToVo(
        dto.campiSpecificiConservazione
      );
      vo.valoriDefaultDocumento = this.mapperValoriDefaultDocumento.convertDtoToVo(
        dto.valoriDefaultDocumento
      );
      vo.perSempre = dto.perSempre;
      vo.ereditaDaFascicolo = dto.ereditaDaFascicolo;
      vo.codice = dto.codice;
      vo.dataManuale = dto.dataManuale;
      vo.descrizione = dto.descrizione;
      vo.motivazione = dto.motivazione;
      vo.campiSpecificiFascicolo = dto.campiSpecificiFascicolo;
      // TODO terminare
      return vo;
    } else {
      return null;
    }
  }
  convertListVoToDto(e: TipologiaDocumentoVO[]): TipologiaDocumentoDTO[] {
    throw new Error("Method not implemented.");
  }
  convertListDtoToVo(dtoList: TipologiaDocumentoDTO[]): TipologiaDocumentoVO[] {
    if (dtoList != null) {
      return dtoList.map((dto) => this.convertDtoToVo(dto));
    } else {
      return null;
    }
  }
}
